import React from "react";
import ContentBox from "../../../components/content-box/ContentBox";
import PageActions from "../../base/PageActions";
import _image_service from "../../../services/ImageService";
import '../../styles/Common.scss';
import '../../styles/Adventurers.scss';
import './AdventurersContactPage.scss';

interface ContactPageProps {
}

const AdventurersContactPage = (props: ContactPageProps) => {

    const page: PageActions = new PageActions({
        title: `Contact - Caudalglen Guild of Adventurers`,
        description: `Contact Chase over email or drop him a note on social media!`,
        keywords: ["contact", "contact info", "contact information", "email", "social links"],
        imgSrc: `cga/assets/contact_chase.png`,
        url: `cga/contact`
    });

    return page.generateMetaContent(
        <>
            <ContentBox className="guild-contact" design="scroll">
                <div>
                    <h2>Chase the Fox</h2>
                    <h4 className="center">Website administrator, designer, coder, and artist</h4>
                    <table className="contact-table">
                        <tbody>
                        <tr>
                            <td>
                                <img className="contact-image"
                                     src={_image_service.getCdnImageSrc(`common/media/email_icon.png`)}
                                     alt="Email"/>
                            </td>
                            <td>chasereynard [[at]] gmail.com</td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://bsky.app/profile/chasetheredfox.bsky.social" target="_blank"
                                   rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/bluesky_logo.png`)}
                                        alt="Bluesky"/>
                                </a>
                            </td>
                            <td><a href="https://bsky.app/profile/chasetheredfox.bsky.social"
                                   target="_blank"
                                   rel="noopener noreferrer">chasetheredfox</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://www.furaffinity.net/user/chasereynard" target="_blank"
                                   rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/fa_logo.png`)}
                                        alt="FurAffinity"/>
                                </a>
                            </td>
                            <td><a href="https://www.furaffinity.net/user/chasereynard"
                                   target="_blank"
                                   rel="noopener noreferrer">ChaseReynard</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://deviantart.com/ChaseReynard" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="contact-image"
                                        src={_image_service.getCdnImageSrc(`common/media/da_logo.png`)}
                                        alt="DeviantArt"/>
                                </a>
                            </td>
                            <td><a href="https://deviantart.com/ChaseReynard"
                                   target="_blank"
                                   rel="noopener noreferrer">ChaseReynard</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="contact-right">
                    <img
                        className="character-pic"
                        src={_image_service.getCdnImageSrc(`cga/assets/contact_chase.png`)}
                        alt="Contact Chase"/>
                </div>
            </ContentBox>
        </>
    );
}

export default AdventurersContactPage;